module.exports = __webpack_public_path__ + "static/media/SarahSwitek_10_Questions_13.55779ef9.mp3";